import React, { useEffect, useState } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import WithListingPageContext from '../../WithListingPageContext'

const perPageOptions = [{
  value: 40,
  label: '40',
}, {
  value: 80,
  label: '80',
}, {
  value: 120,
  label: '120',
}]

function PerPage({ perPage = 120, setSelectedFilters, locale = 'en' }) {
  const [perPageParam, setPerPageParam] = useState(perPage)
  const perPageLabel = i18n.t('listingPage.filters.perPage', { ns: 'rails', lng: locale })

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const param = urlParams.get('per_page')
    setPerPageParam(param ? Number(param) : perPage)
  }, [])

  const handlePerPageChange = (newValue) => {
    setSelectedFilters({ name: 'per_page', value: newValue })
    setPerPageParam(newValue)
  }

  return (
    <div className="metaverse-pagination-new__per-page">
      <span className="cgt-legacy-heading-h6 cgt-legacy-color-typography-disabled">
        {perPageLabel}
      </span>
      <div className="metaverse-pagination-new__per-page-selector">
        {perPageOptions.map(({ value, label }, index) => {
          return (
            <Button
              key={`per-page-option-${label}-${index}`}
              type="ghost"
              onClick={() => handlePerPageChange(value)}
              isActive={value === perPageParam}
            >
              {label}
            </Button>
          )
        })}
      </div>
    </div>
  )
}

PerPage.propTypes = {
  perPage: number,
  setSelectedFilters: func.isRequired,
  locale: string,
}

const mapStateToProps = ({
  setSelectedFilters,
  currentMeta: { perPage },
  locale,
}) => {
  return {
    perPage,
    setSelectedFilters,
    locale,
  }
}

export default WithListingPageContext(mapStateToProps)(PerPage)
